export default defineNuxtRouteMiddleware(to => {
    if (to.path === '/' || to.path.includes('socket.io')) {
        return;
    }
    if (to.path.endsWith('/')) {
        return navigateTo(
            {
                ...to,
                path: to.path.slice(0, -1),
            },
            { replace: true, redirectCode: 301 }
        );
    }
});
